export const environment = {
  strapiApiUrl: 'https://nvv-strapi-prod.azurewebsites.net/api/',
  strapiUrl: 'https://nvv-strapi-prod.azurewebsites.net',
};